/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectFile } from '../models/project-file';

@Injectable({
  providedIn: 'root',
})
export class FileManagementControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fileManagementControllerGetFileContent
   */
  static readonly FileManagementControllerGetFileContentPath = '/file-management/content/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFileContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
  }): Observable<StrictHttpResponse<ProjectFile>> {

    const rb = new RequestBuilder(this.rootUrl, FileManagementControllerService.FileManagementControllerGetFileContentPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectFile>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFileContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;
    id: string;
  }): Observable<ProjectFile> {

    return this.getFileContent$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectFile>) => r.body as ProjectFile)
    );
  }

  /**
   * Path part for operation fileManagementControllerGetFiles
   */
  static readonly FileManagementControllerGetFilesPath = '/file-management/files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFiles$Response(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
  }): Observable<StrictHttpResponse<Array<ProjectFile>>> {

    const rb = new RequestBuilder(this.rootUrl, FileManagementControllerService.FileManagementControllerGetFilesPath, 'get');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectFile>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFiles(params?: {
    publicAPIKey?: string;
    secretAPIKey?: string;
  }): Observable<Array<ProjectFile>> {

    return this.getFiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectFile>>) => r.body as Array<ProjectFile>)
    );
  }

  /**
   * Path part for operation fileManagementControllerUpload
   */
  static readonly FileManagementControllerUploadPath = '/file-management/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload$Response(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<StrictHttpResponse<ProjectFile>> {

    const rb = new RequestBuilder(this.rootUrl, FileManagementControllerService.FileManagementControllerUploadPath, 'post');
    if (params) {
      rb.header('publicAPIKey', params.publicAPIKey, {});
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectFile>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload(params: {
    publicAPIKey?: string;
    secretAPIKey?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<ProjectFile> {

    return this.upload$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectFile>) => r.body as ProjectFile)
    );
  }

}
